<template>
  <modal
    id="welcome-back-modal"
    :size="'lg'"
    :confirm-text="'Return to dashboard'"
    confirm-class="btn-default pull-left"
    close-class="btn-primary"
    :close-text="'Resume'"
    :show-exit="false"
    @closed="resume"
    @confirm="exitToDashboard"
  >
    <template v-slot:title><h1>Welcome Back</h1></template>
    <template v-slot:body>
      <h3 class="text-center">Are you ready to continue where you left off?</h3>

      <template v-if="role.role">
        <section class="mt-20">
          <h4>Role:</h4>
          <p v-html="role.role"></p>
        </section>
      </template>
      <template v-if="role.scenario">
        <section class="mt-20">
          <h4>Opening Scene:</h4>
          <p v-html="role.scenario"></p>
        </section>
      </template>
      <section>
        <div class="box text-center p-20">
          <div>
            <strong>When you resume, it might be helpful to review the Sent folder.</strong>
          </div>
          <div>There you can review previous emails that you have interacted with.</div>
        </div>
      </section>
    </template>
  </modal>
</template>

<script>
  import Modal from '@shared/Modal.vue';
  import { mapActions } from 'vuex';
  export default {
    components: {
      Modal,
    },

    props: {
      role: {
        type: Object,
        default: {},
      },
    },
    methods: {
      ...mapActions('time', ['initializeClock']),
      async exitToDashboard() {
        window.location.href = '/capsiminbox/student/dashboard';
      },
      async resume() {
        await this.initializeClock();
        this.$emit('exit', true);
        $('#welcome-back-modal').modal('hide');
      },
    },
    computed: {},
  };
</script>
<style lang="scss" scoped>
  .box {
    background: #eef6f9;
  }
</style>
